function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m18.63 32.523-2.604-6.117c2.508-.927 4.856-2.173 7.029-3.626l-4.425 9.743ZM6.665 17.045.547 14.442l9.744-4.425c-1.454 2.173-2.7 4.52-3.626 7.028ZM28.358 3.468c.447 0 .846 0 1.182.08.271 2.22-.032 6.789-5.271 12.028-2.716 2.731-5.959 4.824-9.601 6.213l-3.434-3.354c1.47-3.69 3.562-6.932 6.261-9.632 4.41-4.408 8.339-5.335 10.863-5.335Zm0-3.195c-3.163 0-7.955 1.103-13.13 6.278-3.5 3.498-5.592 7.348-6.95 10.718a3.224 3.224 0 0 0 .735 3.402l3.403 3.387c.607.607 1.421.974 2.268.974.367 0 .75-.096 1.118-.24a30.51 30.51 0 0 0 10.719-6.948C35.562 8.804 32.176.896 32.176.896S30.722.273 28.358.273ZM20.882 12.19a3.2 3.2 0 0 1 0-4.52 3.201 3.201 0 0 1 4.52 0c1.23 1.245 1.247 3.274 0 4.52a3.201 3.201 0 0 1-4.52 0ZM7.623 32.22l5.815-5.814a4.883 4.883 0 0 1-1.55-.72L5.372 32.22h2.252Zm-6.773 0h2.253l7.62-7.603-2.269-2.253L.85 29.968v2.252Zm0-4.52 6.534-6.518a4.725 4.725 0 0 1-.719-1.549L.85 25.447V27.7Z",
  fill: "#F2F2F2"
});

function SvgIconRocket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRocket);
export default __webpack_public_path__ + "static/media/icon-rocket.7b01c7b7c1bd74daa88dd047b51add56.svg";
export { ForwardRef as ReactComponent };